enum Urls {
    mapJS = "https://sdk.woosmap.com/map/map.js",
    widgetJS = "https://sdk.woosmap.com/map/widgets.js"
}

export default Urls;
